import React, { Component } from 'react'
import { Growl } from 'primereact/growl'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {  Message } from 'primereact/message'
import { Card } from 'primereact/card'
import { Paginator } from 'primereact/paginator'

import servicioObjetos from '../../servicio/ServicioObjetos';
import servicioHttp from '../../servicio/ServicioHttp';

export class AdministracionTrabajadores extends Component {
    constructor() {
    super()
    this.state = {
        usuario: {},
        trabajador:{},
        errores: {},
        paginacion: { registrosPorPagina: 20},

        inicio: 0,
        objetoLike: {}                                
        
        }
    }

    componentDidMount() {
         this.obtenerPagina();
    }

    cambiaPagina = (event) => {
        let { paginacion } = this.state
        paginacion.numeroPagina = event.page
        paginacion.registrosPorPagina = event.rows 
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    
    obtenerPagina() {
        let { paginacion } = this.state;        
        servicioHttp.consumirPostHttp("/usuario/consulta/trabajadorUsuario.json", paginacion).then(response => {
            this.growl.show({ severity: response.data.error === false ? "success" : "error", summary: "", detail: response.data.mensaje, });
            this.setState({ paginacion: response.data.objeto });            
            console.log(response);
        }).catch((error) => {
            console.log(paginacion);
            this.growl.show({
                severity: "error", summary: "", detail: "Se genero un error no esperado, por favor inténtelo de nuevo",
            });
        });
    }

    cambiarCorreo = () => {
        let { usuario } = this.state;
        let validacion = this.validarFormulario(usuario);
        this.setState({ errores: validacion });

        if (servicioObjetos.esObjetoVacio(validacion)) {
            let usuarioCopia = JSON.parse(JSON.stringify(usuario));                        
            servicioHttp
                .consumirPostHttp("/usuario/consulta/cambiarCorreo.json", usuarioCopia)
                .then((response) => {                    
                    this.growl.clear();
                    this.growl.show({ severity: 'success', detail: response.data.mensaje, life: 2000 });                    
                    usuario.usuario = ""
                    usuario.correo = ""                    
                    this.obtenerPagina();                                                                              
                }).catch((e) => {
                     this.growl.show({
                         severity: "error", summary: "", detail: "Se generó un error no esperado, por favor inténtelo de nuevo",
                     });
                });
        }
    }

    validarFormulario = (usuario) => {
        const errores = {};
        var expReg = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
        var validacionCurp = expReg.exec(usuario.usuario);

        var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var validacionCorreo = expreReg.exec(usuario.correo);

        if (servicioObjetos.esObjetoVacio(usuario.usuario))
            errores.usuario = "El usuario (CURP) es requerido";
        
        if (servicioObjetos.esObjetoVacio(validacionCurp))
            errores.usuario = "La usuario no es válido"
        
        if (servicioObjetos.esObjetoVacio(usuario.correo))        
            errores.correo = "El correo no es requerido";

        if (servicioObjetos.esObjetoVacio(validacionCorreo))
            errores.correo = "El correo no es válido"
        
        return errores;
    }

    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }

    buscarLike() {
        let { trabajador, paginacion } = this.state
        servicioHttp
                .consumirPostHttp("/usuario/consulta/trabajador_usuario_curp.json", trabajador)
                .then((response) => {   
            if (response.data.lista.length === 0) {
                this.growl.show({ life: 5000, severity: 'error', summary: '', detail: response.data.mensaje });
                paginacion['datos'] = response.data.lista;
                this.setState({ paginacion });
            } else {
                this.growl.show({ life: 1000, severity: 'success', summary: '', detail: "Valores encontrados" });
                paginacion['datos'] = response.data.lista;
                this.setState({ paginacion });
            }
        })
    }

    
    render () {

        let {errores, inicio, paginacion, usuario ,trabajador} =  this.state;

        return(<div className='p-grid'>
            <Growl ref={(el) => this.growl = el} />
                    
            <Card className='p-col-12 p-md-12'>
                <h1 style={{ textAlign: 'center', fontSize: '30px', fontWeight: 'bolder' }}> ADMINISTRACIÓN DE TRABAJADORES </h1>            
            </Card>
            <Card className='p-col-12 p-md-12'>Buscar por CURP
            <div className="p-fluid p-grid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="buscar"></label>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <InputText className="p-inputtext" placeholder="Buscar por curp" name="trabajador.usuario" value={trabajador.usuario || ''}
                            onChange={this.asignarValores} onKeyUp={this.buscarLike.bind(this)} />
                    </div>
                </div>
                 </Card>   
            <div className="p-grid p-fluid" style={{justifyContent: 'center', margin: '2rem 2rem 1rem 2rem' }}>                    
                
                <div className='p-col-12 p-md-2'></div>
                <div className="p-col-12 p-md-2" style={{textAlign:'center', alignSelf:'center'}}>
                    <label htmlFor="">* CURP: </label>
                </div>                    
                <div className="p-col-12 p-md-5" >
                    <InputText placeholder="CURP" className={errores.usuario ? 'p-error ' : ''} 
                        onChange={(e) => { this.asignarValores(e, true) }} id="usuario.usuario" name="usuario.usuario"
                            value={usuario.usuario || ''} />
                    {errores.usuario ? <div> <Message severity="error" text={errores.usuario} /> </div> : null}
                </div>
                <div className='p-col-12 p-md-3'></div>
                
                
                <div className='p-col-12 p-md-2'></div>
                <div className="p-col-12 p-md-2" style={{textAlign:'center', alignSelf:'center'}}>
                    <label htmlFor="">* Correo: </label>
                </div>
                <div className="p-col-12 p-md-5" >
                    <InputText placeholder="Correo electrónico" className={errores.correo ? 'p-error ' : ''} 
                    onChange={(e) => { this.asignarValores(e, false) }} id="usuario.correo" name="usuario.correo"
                            value={usuario.correo || ''} />
                    {errores.correo ? <div> <Message severity="error" text={errores.correo} /> </div> : null}
                </div>            
                <div className='p-col-12 p-md-3'></div>

                <div className='p-col-12 p-md-6'></div>
                <div className='p-col-12 p-md-3'>
                <Button icon='pi pi-pencil' onClick={this.cambiarCorreo} label="Cambiar correo"style={{ marginRight: '20px' }} />
                </div>
                <div className='p-col-12 p-md-3'></div>
                </div> 

                <div style={{marginTop:'3rem'}}></div>
                
                <Card>            
                <DataTable value={paginacion.datos} layout={this.state.layout}
                            header="MIS RECIBOS" resizableColumns={true} style={{justifyContent:'center'}}>                   
                            <Column field="id" header="No" sortable={true} style={{textAlign:'center', width:'5rem'}}/>
                            <Column field="nombre" header="Nombre" sortable={true} style={{textAlign:'center'}}/>
                            <Column field="usuario" header="CURP" sortable={true} style={{textAlign:'center'}}/>                            
                            <Column field="correo" header="Correo" sortable={true} style={{textAlign:'center'}}/>
                        </DataTable>
                        <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </Card>
            </div>
        )
    }
}